import React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgRteOutdent = function SvgRteOutdent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M5 6a1 1 0 011-1h12a1 1 0 110 2H6a1 1 0 01-1-1zm7 8a1 1 0 011-1h5a1 1 0 110 2h-5a1 1 0 01-1-1zm1-5a1 1 0 100 2h5a1 1 0 100-2h-5zm-8 9a1 1 0 011-1h12a1 1 0 110 2H6a1 1 0 01-1-1zm4.04-8.9c.41-.262.96.02.96.493v4.814c0 .473-.55.755-.96.493l-3.765-2.408a.579.579 0 010-.985L9.04 9.1z"
  })));
};
var rteOutdent = SvgRteOutdent;

export { rteOutdent as default };
